module.exports = __webpack_public_path__ + "static/media/barter-goods.4e795616.jpg";